module.exports = __webpack_public_path__ + "static/img/手持件示例.54507ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/手持件示例.jpg
// module id = OIAP
// module chunks = 1